import { Button, Flex, Icon, Text, useDisclosure, useToast } from "@chakra-ui/react";
import React, { useMemo, useState } from "react";
import { mapServerDataToGridData } from "../utils";
import { FaEye } from "react-icons/fa";
import { DataTable } from "../../../../../../components/DataTable";
import { SuppliersDataModal } from "./index";
import { useTranslation } from "react-i18next";
import { useGetSuppliersDataReport } from "../../../../../../hooks/query/reports";
import { showErrorToast } from "../../../../../../utils";
import { MissingDataLabel } from "../../../../components/MissingDataLabel";
import { Card } from "../../../../../../components/Card";

function SuppliersDataListed({ selectedYear, selectedQuarter }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.suppliersData"
  });
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [suppliersList, setSuppliersList] = useState([]);
  const [selectedQuestionnaireId, setSelectedQuestionnaireId] = useState("");

  const handleErrors = (err) => {
    if (err.response?.status === 404) {
      return;
    }
    showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message);
  };

  useGetSuppliersDataReport({
    year: selectedYear,
    quarter: selectedQuarter
  }, {
    onSuccess: (data) => {
      setSuppliersList(mapServerDataToGridData(data));
    },
    onError: err => handleErrors(err),
    refetchOnWindowFocus: false,
    cacheTime: 0
  });

  const columns = useMemo(() => {
      function handleView(data) {
        setSelectedQuestionnaireId(data.row.original.id);
        onOpen();
      }

      return [
        {
          header: "Description",
          accessorKey: "description",
          size: 150
        },
        {
          header: "Supplier",
          accessorKey: "supplier",
          size: 250
        },
        {
          header: "Assignee",
          accessorKey: "assigneeName",
          size: 150
        },
        {
          header: <div style={{ textAlign: "left" }}><b>Actions</b></div>,
          accessorKey: "action",
          size: 90,
          cell: (row) => (
            <Flex align="center">
              <Button onClick={() => handleView(row)} variant="ghost" title="View Data">
                <Icon
                  as={FaEye}
                  inlineSize="4"
                  blockSize="4"
                  opacity="0.7"
                />
              </Button>
            </Flex>
          )
        }
      ];
    }, [onOpen]
  );

  const closeModal = () => {
    setSelectedQuestionnaireId("");
    onClose();
  };

  return (
    <Card boxShadow="xs">
      {suppliersList && suppliersList.length !== 0 ? <>
        <Text opacity="0.75" fontSize="md" marginBottom={3}>
          {t("listedSubTitle")}
        </Text>
        <DataTable
          data={suppliersList}
          columns={columns}
          containerHeight="var(--chakra-sizes-2xl)"
        />
        <SuppliersDataModal
          questionnaireId={selectedQuestionnaireId}
          isOpen={isOpen}
          onClose={closeModal}
        />
      </> : <MissingDataLabel />}
    </Card>
  );
}

export default SuppliersDataListed;